import React, { Component } from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { nest, sum, ascending, merge } from "d3";
import moment from "moment";
import { Box } from "rebass";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

import ComissionTooltip from "./ComissionTooltip";

const setDefaultRangeDate = (fromDate, toDate) => {
  const range = moment.range(fromDate, toDate);
  const acc = Array.from(
    range.by("days", { excludeStart: false, excludeEnd: false })
  );
  const resultCommissions = acc.map(m => {
    return {
      date: m.format("YYYY-MM-DD"),
      marketer: 0,
      agency: 0
    };
  });
  return resultCommissions;
};

class AmountChart extends Component {
  constructor(props) {
    super(props);
    const dataCommissions =
      props.data && props.data.length > 0
        ? this.getDataCommissions(props.data)
        : setDefaultRangeDate(
            moment()
              .subtract(6, "d")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          );

    this.state = {
      dataCommissions: dataCommissions
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length > 0) {
      this.state = {
        dataCommissions: this.getDataCommissions(nextProps.data)
      };
    } else {
      this.state = {
        dataCommissions: setDefaultRangeDate(
          moment()
            .subtract(6, "d")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        )
      };
    }
  }

  getDataCommissions = data => {
    let dataCommissions = nest()
      .key(function(d) {
        return moment(d.date).format("YYYY-MM-DD");
      })
      .sortKeys(ascending)
      .key(function(d) {
        return d.type;
      })
      .rollup(function(view) {
        return sum(view, function(d) {
          return d.amount;
        });
      })
      .entries(data)
      .map(function(group) {
        const commissions = group.values;
        const typeCommissions = nest()
          .key(function(d) {
            return d.key;
          })
          .rollup(function(view) {
            return sum(view, function(d) {
              return d.value;
            });
          })
          .entries(commissions);

        let result = {};
        for (let i = 0; i < typeCommissions.length; i++) {
          result[typeCommissions[i].key] = typeCommissions[i].value;
        }
        result.date = group.key;
        return result;
      });
    if (dataCommissions.length > 0) {
      const fromDate = dataCommissions[0].date;
      const toDate = dataCommissions[dataCommissions.length - 1].date;
      const defaultCommissions = setDefaultRangeDate(fromDate, toDate);
      const newDataOrders = merge([dataCommissions, defaultCommissions]);

      let newData = nest()
        .key(function(d) {
          return moment(d.date).format("YYYY-MM-DD");
        })
        .sortKeys(ascending)
        .rollup(function(view) {
          return {
            agency: sum(view, function(d) {
              return d.agency;
            }),
            marketer: sum(view, function(d) {
              return d.marketer;
            })
          };
        })
        .entries(newDataOrders)
        .map(function(group) {
          const commissions = group.value;

          let result = {
            date: group.key,
            marketer: commissions.marketer,
            agency: commissions.agency
          };
          return result;
        });

      return newData;
    }

    return dataCommissions;
  };

  render() {
    const { dataCommissions } = this.state;

    return (
      <Box w={[1]} p={[1]}>
        <ContainerDimensions>
          {({ width, height }) => {
            let mainWidth = width - 50;
            let mainHeight = mainWidth / 2;
            if (width < 600) {
              // mainWidth = 800;
              mainHeight = mainWidth / 1.8;
            }
            return (
              <LineChart
                width={mainWidth}
                height={mainHeight}
                data={dataCommissions}
                margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
              >
                <XAxis dataKey="date" />
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip content={<ComissionTooltip />} />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="agency"
                  stroke="#FF9900"
                  activeDot={{ r: 8 }}
                />
                <Line
                  type="monotone"
                  dataKey="marketer"
                  stroke="#8884d8"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            );
          }}
        </ContainerDimensions>
      </Box>
    );
  }
}

AmountChart.propTypes = {
  data: PropTypes.array
};

AmountChart.defaultProps = {
  data: []
};

export default AmountChart;



// WEBPACK FOOTER //
// ./src/agency/commissions/AmountChart.js